import React, { useState } from "react";
import Hero from "./HeroSection/Hero";
import styled from "styled-components";
import JsonData from "../data/data.json"
import { PreguntasyRespuestas } from "./UI/PreguntasyRespuestas";
import { ConsultaPQR } from "./UI/ConsultaPQR";
import useConfigs from "../hooks/useConfigs";

// ##### Estilos #####
const Container = styled.div`
  position: relative;
`;

const ContPreguntas = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 5rem;
  `;

  const SelectView = styled.select`
  background-color: ${(props) =>
    props.themeSelected === "light"
      ? props.theme.azulPpal
      : props.theme.blanco};
  width: 100%;
  color: ${(props) =>
    props.themeSelected === "light"
        ? props.theme.blanco
        : props.theme.darkVerde
  };
  padding: 1rem 3rem;
  box-sizing: border-box;
  border-radius: 40px;
  border-style: none;
  text-transform: uppercase;
  font-weight: bold;
  max-width: 700px;
  transition: all 0.3s;

  &:focus{
    border-radius: 40px 40px 0 0;
    border-style: none;
  }

  option {
    color: var(--azul-ppal);
    background-color: #fff;
    width: 40% !important;
    border-style: none;
    text-transform: uppercase;
    font-weight: bold;
    line-height: 1.5em;
  }
`;

export const PagePreguntasFrecuentes = () => {
  window.scroll(0, 0)

  const [ viewPqr, setViewPqr] = useState("fqs")
  const { fontSizeMultiplier, theme, themeSelected } = useConfigs();

  return (
    <Container>
      <Hero
        title="Preguntas frecuentes"
        subtitle="RESUELVE TUS PREGUNTAS, QUEJAS Y RECLAMOS"
        color={ themeSelected == "light" ? "#ffff" : "#012b2b"}
        imgSrc="img/Servicios/consultas-quejas-reclamos.jpg"
      />

      <ContPreguntas className="container">
        <SelectView 
        fontSizeMultiplier={fontSizeMultiplier}
        theme={theme}
        themeSelected={themeSelected}
        value={viewPqr}
        onChange={(e) => setViewPqr(e.target.value)}
        >
          <option value="fqs">Preguntas Freceuntes</option>
          <option value="consultas">Consultas</option>
        </SelectView>
        { viewPqr === "fqs" ? <PreguntasyRespuestas data={JsonData.PreguntasyRespuestas}/> : <ConsultaPQR /> }
      </ContPreguntas>

    </Container>
  );
};
